import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Divider, Tabs, Rate, Skeleton, Carousel } from 'antd';
import { FaMapMarkedAlt, FaPhone } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import 'react-image-gallery/styles/css/image-gallery.css';
import RoomDetailsModalTripjack from './RoomDetailsModalTripjack';
import RoomsTabTripjack from './RoomsTabTripjack';
import OverviewTabTripjack from './OverviewTabTripjack';
import AmenitiesTabTripjack from './AmenitiesTabTripjack';
import PaymentFareCardTripjack from './PaymentFareCardTripjack';
import MobilePaymentFareCardTripjack from './MobilePaymentFareCardTripjack';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";

const HotelReviewTripjack = ({
    loading,
    hotelDetails,
    vendor,
    totalRooms
}) => {
    const navigate = useNavigate();
    const [openRoomDetails, setOpenRoomdetails] = useState(null);
    const [openRoomDetailsData, setOpenRoomdetailsData] = useState([]);
    const [openRoomDetailsUpdate, setOpenRoomdetailsUpdate] = useState(null);
    const allImages = hotelDetails?.hotel?.img?.filter(img => img?.sz === 'XXL') || [];

    const handleNavigate = () => {
        navigate("/hotel-payment", { state: { openRoomDetailsUpdate, vendor, hotelDetails } });
    };

    const checkRoomdetails = (moreHotel) => {
        if (moreHotel?.ris && moreHotel.ris.length > 0 && moreHotel.ris[0]?.pis && moreHotel.ris[0].pis.length > 0) {
            setOpenRoomdetailsData(moreHotel)
            setOpenRoomdetails(true)
        } else {
            console.error("Missing data in moreHotel:", moreHotel);
        }
    }

    useEffect(() => {
        Fancybox.bind("[data-fancybox]", {
            Thumbs: false,
            Toolbar: true,
            groupAll: true,
        });

        return () => {
            Fancybox.destroy();
        };
    }, [allImages]);




    return (
        <section className="container-fluid hotel_confirm mb-4">
            <section className="bg-white sticky border-top">
                <div className="container py-3">
                    <div className="ant-row css-dev-only-do-not-override-17seli4">
                        {!loading &&
                            <div className="ant-col ant-col-xs-24 ant-col-md-12 css-dev-only-do-not-override-17seli4">
                                <h2 className="mb-1">{hotelDetails?.hotel?.name}</h2>
                                <div className="ratings d-flex align-items-center gap-2 mb-2">
                                    <div className="d-flex align-items-center">
                                        <ul className="d-flex align-items-center gap-1 p-0 m-0">
                                            <Rate disabled value={hotelDetails?.hotel?.rt} />
                                        </ul>
                                        <span className="ms-2">{hotelDetails?.hotel?.pt}</span>
                                    </div>
                                    |
                                    <div>
                                        <b className="bg-success">{hotelDetails?.hotel?.rt}/5</b>
                                        <p className="d-none d-md-inline mb-0 ms-2">Ratings</p>
                                    </div>
                                </div>
                                <h6><FaMapMarkedAlt className="me-1" />{hotelDetails?.hotel?.ad?.adr},{hotelDetails?.hotel?.ad?.adr2}</h6>
                                {hotelDetails?.hotel?.cnt?.ph && <h6><FaPhone className="me-1" />{hotelDetails?.hotel?.cnt?.ph}</h6>}
                            </div>
                        }
                    </div>
                </div>
            </section>
            <section className='bg-white py-1 mb-4'>
                <div className='container'>

                    {loading ? (
                        <Row gutter={16} className="hotel_confirm_images">
                            <Col md={12} xs={24} className='d-md-block d-none'>
                                <Skeleton.Image active className="w-100" style={{ height: '435px' }} />
                            </Col>
                            <Col md={6} xs={24} className='d-md-block d-none'>
                                <Skeleton.Image active className="w-100 mb-2" style={{ height: '210px' }} />
                                <Skeleton.Image active className="w-100 mb-2" style={{ height: '210px' }} />
                            </Col>
                            <Col md={6} xs={24}>
                                <Skeleton.Image active className="w-100 mb-2" style={{ height: '210px' }} />
                                <Skeleton.Image active className="w-100 mb-2" style={{ height: '210px' }} />
                            </Col>
                        </Row>
                    ) : allImages?.length < 5 ? (
                        // Show carousel when less than 5 images
                        <div className='my-4' style={{ position: 'relative' }}>
                            <Carousel arrows dots>
                                {allImages.map((img, index) => (
                                    <div key={index}>
                                        <img
                                            src={img.url}
                                            alt={`Slide ${index + 1}`}
                                            className="img-fluid w-100"
                                            style={{ height: '435px', objectFit: 'cover', borderRadius: '12px' }}
                                        />
                                    </div>
                                ))}
                            </Carousel>

                            <a
                                className="position-absolute  d-flex align-items-center text-white"
                                style={{
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    borderRadius: '5px',
                                    bottom: '20px',
                                    color: '#fff',
                                    padding: '2px 10px',
                                    right: '10px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (allImages.length > 0) {
                                        Fancybox.show(
                                            allImages.map((image, index) => ({
                                                src: image.url,
                                                thumb: image.url,
                                                caption: `Image ${index + 1} of ${allImages.length}`,
                                            })),
                                            {
                                                groupAll: true,
                                                startIndex: 0,
                                                Thumbs: {
                                                    autoStart: true,
                                                    type: 'classic',
                                                    axis: 'y',
                                                },
                                                Images: {
                                                    zoom: true,
                                                },
                                            }
                                        );
                                    }
                                }}
                            >
                                See all {allImages.length} photos
                            </a>
                        </div>
                    ) : (
                        // Show grid layout when 5+ images
                        <Row gutter={16} className="hotel_confirm_images">
                            <>
                                <Col md={12} xs={24} className='d-md-block d-none'>
                                    {loading ? (
                                        <Skeleton.Image active className="w-100" style={{ height: '435px' }} />
                                    ) : (
                                        <a data-fancybox="dynamic-gallery" href={allImages?.[0]?.url}>
                                            <img
                                                src={allImages?.[0]?.url}
                                                alt="Hotel"
                                                className="img-fluid rounded"
                                                style={{ height: '435px' }}
                                            />
                                        </a>
                                    )}
                                </Col>

                                <Col md={6} xs={24} className='d-md-block d-none'>
                                    {loading ? (
                                        <Skeleton.Image active={true} className="w-100 mb-2" style={{ height: '210px' }} />
                                    ) : (
                                        <a data-fancybox="dynamic-gallery" href={allImages?.[1]?.url}>
                                            <img
                                                src={allImages?.[1]?.url}
                                                className="img-fluid rounded"
                                            />
                                        </a>
                                    )}
                                    {loading ? (
                                        <Skeleton.Image active={true} className="w-100 mb-2" style={{ height: '210px' }} />
                                    ) : (
                                        <a data-fancybox="dynamic-gallery" href={allImages?.[2]?.url}>
                                            <img
                                                src={allImages?.[2]?.url}
                                                className="img-fluid rounded"
                                            />
                                        </a>
                                    )}
                                </Col>

                                <Col md={6} xs={24}>
                                    {loading ? (
                                        <Skeleton.Image active={true} className="w-100 mb-2" style={{ height: '210px' }} />
                                    ) : (
                                        <a data-fancybox="dynamic-gallery" href={allImages?.[3]?.url}>
                                            <img
                                                src={allImages?.[3]?.url}
                                                className="img-fluid rounded d-md-inline d-none"
                                            />
                                        </a>
                                    )}

                                    <div className="more_photos position-relative">
                                        {loading ? (
                                            <Skeleton.Image active={true} className="w-100 mb-2" style={{ height: '210px' }} />
                                        ) : (
                                            <>
                                                <a data-fancybox="dynamic-gallery" href={allImages?.[4]?.url}>
                                                    <img
                                                        src={allImages?.[4]?.url}
                                                        className="img-fluid rounded"
                                                    />
                                                </a>

                                                {allImages?.map((img, index) => (
                                                    <a
                                                        key={index}
                                                        href={img}
                                                        style={{ display: 'none' }}
                                                    >
                                                        <img src={img} alt={`Hotel ${index}`} />
                                                    </a>
                                                ))}

                                                <a
                                                    className="position-absolute d-flex align-items-center"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (allImages.length > 0) {
                                                            Fancybox.show(
                                                                allImages.map((image, index) => ({
                                                                    src: image.url,
                                                                    thumb: image.url,
                                                                    caption: `Image ${index + 1} of ${allImages.length}`
                                                                })),
                                                                {
                                                                    groupAll: true,
                                                                    startIndex: 0,
                                                                    Thumbs: {
                                                                        autoStart: true,
                                                                        type: 'classic',
                                                                        axis: 'y'
                                                                    },
                                                                    Images: {
                                                                        zoom: true
                                                                    }
                                                                }
                                                            );
                                                        }
                                                    }}

                                                >
                                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='me-1'><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18.5116 10.0767C18.5116 10.8153 17.8869 11.4142 17.1163 11.4142C16.3457 11.4142 15.7209 10.8153 15.7209 10.0767C15.7209 9.33801 16.3457 8.7392 17.1163 8.7392C17.8869 8.7392 18.5116 9.33801 18.5116 10.0767Z" fill="#ffffff"></path> <path fillRule="evenodd" clipRule="evenodd" d="M18.0363 5.53205C16.9766 5.39548 15.6225 5.39549 13.9129 5.39551H10.0871C8.37751 5.39549 7.02343 5.39548 5.9637 5.53205C4.87308 5.6726 3.99033 5.96873 3.29418 6.63601C2.59803 7.30329 2.28908 8.14942 2.14245 9.19481C1.99997 10.2106 1.99999 11.5085 2 13.1472V13.2478C1.99999 14.8864 1.99997 16.1843 2.14245 17.2001C2.28908 18.2455 2.59803 19.0916 3.29418 19.7589C3.99033 20.4262 4.87307 20.7223 5.9637 20.8629C7.02344 20.9994 8.37751 20.9994 10.0871 20.9994H13.9129C15.6225 20.9994 16.9766 20.9994 18.0363 20.8629C19.1269 20.7223 20.0097 20.4262 20.7058 19.7589C21.402 19.0916 21.7109 18.2455 21.8575 17.2001C22 16.1843 22 14.8864 22 13.2478V13.1472C22 11.5085 22 10.2106 21.8575 9.19481C21.7109 8.14942 21.402 7.30329 20.7058 6.63601C20.0097 5.96873 19.1269 5.6726 18.0363 5.53205ZM6.14963 6.8576C5.21373 6.97821 4.67452 7.2044 4.28084 7.58175C3.88716 7.95911 3.65119 8.47595 3.52536 9.37303C3.42443 10.0926 3.40184 10.9919 3.3968 12.1682L3.86764 11.7733C4.99175 10.8305 6.68596 10.8846 7.74215 11.897L11.7326 15.7219C12.1321 16.1049 12.7611 16.1571 13.2234 15.8457L13.5008 15.6589C14.8313 14.7626 16.6314 14.8664 17.8402 15.9092L20.2479 17.9862C20.3463 17.7222 20.4206 17.4071 20.4746 17.0219C20.6032 16.1056 20.6047 14.8977 20.6047 13.1975C20.6047 11.4972 20.6032 10.2893 20.4746 9.37303C20.3488 8.47595 20.1128 7.95911 19.7192 7.58175C19.3255 7.2044 18.7863 6.97821 17.8504 6.8576C16.8944 6.73441 15.6343 6.73298 13.8605 6.73298H10.1395C8.36575 6.73298 7.10559 6.73441 6.14963 6.8576Z" fill="#ffffff"></path> <g opacity="0.5"> <path d="M17.0866 2.61039C16.2268 2.49997 15.1321 2.49998 13.7675 2.5H10.6778C9.31314 2.49998 8.21844 2.49997 7.35863 2.61039C6.46826 2.72473 5.72591 2.96835 5.13712 3.53075C4.79755 3.8551 4.56886 4.22833 4.41309 4.64928C4.91729 4.41928 5.48734 4.28374 6.12735 4.20084C7.21173 4.06037 8.5973 4.06038 10.3466 4.06039H14.2615C16.0108 4.06038 17.3963 4.06037 18.4807 4.20084C19.0397 4.27325 19.5453 4.38581 20.0003 4.56638C19.8457 4.17917 19.6253 3.83365 19.3081 3.53075C18.7193 2.96835 17.977 2.72473 17.0866 2.61039Z" fill="#ffffff"></path> </g> </g></svg>
                                                    See all {allImages.length} photos
                                                </a>
                                            </>
                                        )}
                                    </div>
                                </Col>
                            </>
                        </Row>
                    )}

                </div>
            </section>
            <div className='container'>

                <Row gutter={16}>
                    <Col md={17} xs={24}>
                        <Card className="card mb-md-2" loading={loading}>


                            <Tabs
                                defaultActiveKey="rooms"
                                type="card"
                                className="custom-tabs"
                                tabBarStyle={{
                                    borderBottom: "2px solid #d9d9d9",
                                }}
                                tabBarExtraContent={{
                                    style: {
                                        margin: "0 auto",
                                    },
                                }}
                                items={[
                                    {
                                        label: "Rooms",
                                        key: "rooms",
                                        children: (
                                            <RoomsTabTripjack
                                                hotelDetails={hotelDetails}
                                                setOpenRoomdetailsUpdate={setOpenRoomdetailsUpdate}
                                                checkRoomdetails={checkRoomdetails}
                                            />
                                        ),
                                    },
                                    {
                                        label: "Overview",
                                        key: "overview",
                                        children: (
                                            <OverviewTabTripjack hotelDetails={hotelDetails} />
                                        ),
                                    },
                                    {
                                        label: "Amenities",
                                        key: "amenities",
                                        children: (
                                            <AmenitiesTabTripjack hotelDetails={hotelDetails} />
                                        ),
                                    },
                                ]}
                            />
                            <Divider />
                        </Card>
                    </Col>


                    <Col md={7} xs={24} className='w-100'>
                        <PaymentFareCardTripjack
                            loading={loading}
                            openRoomDetailsUpdate={openRoomDetailsUpdate}
                            hotelDetails={hotelDetails}
                            totalAdults={2}
                            totalChildren={1}
                            handleNavigate={handleNavigate}
                            totalRooms={totalRooms}
                        />
                        <MobilePaymentFareCardTripjack
                            loading={loading}
                            openRoomDetailsUpdate={openRoomDetailsUpdate}
                            hotelDetails={hotelDetails}
                            totalAdults={2}
                            totalChildren={1}
                            handleNavigate={handleNavigate}
                        />
                    </Col>
                </Row>

                <RoomDetailsModalTripjack
                    open={openRoomDetails}
                    onClose={() => setOpenRoomdetails(false)}
                    roomData={openRoomDetailsData}
                    hotelDetails={hotelDetails}
                    openRoomDetailsUpdate={openRoomDetailsUpdate}
                />
            </div>

        </section>
    );
};

export default HotelReviewTripjack;